import React, {
   PropsWithChildren,
   createContext,
   useContext,
   useRef
} from 'react'

import NotificationsStore from '../../stores/NotificationsStore'

const NotificationsStoreContext = createContext<NotificationsStore | null>(null)

export const NotificationsStoreProvider = (
   props: PropsWithChildren
): React.ReactElement => {
   const notificationsStoreRef = useRef<NotificationsStore>(
      NotificationsStore.create()
   )

   return (
      <NotificationsStoreContext.Provider value={notificationsStoreRef.current}>
         {props.children}
      </NotificationsStoreContext.Provider>
   )
}

export const useNotificationsStore = (): NotificationsStore => {
   const notificationsStore = useContext<NotificationsStore | null>(
      NotificationsStoreContext
   )

   if (!notificationsStore) {
      throw new Error('Expected to be wrapped in Notifications Store Provider')
   }

   return notificationsStore
}
